import type { SVGProps } from 'react';

function IconBagShopping(props: SVGProps<SVGSVGElement>) {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 640" fill="none" {...props}>
            <path
                d="M256 144L256 192L384 192L384 144C384 108.7 355.3 80 320 80C284.7 80 256 108.7 256 144zM208 240L144 240L144 448C144 474.5 165.5 496 192 496L448 496C474.5 496 496 474.5 496 448L496 240L432 240L432 296C432 309.3 421.3 320 408 320C394.7 320 384 309.3 384 296L384 240L256 240L256 296C256 309.3 245.3 320 232 320C218.7 320 208 309.3 208 296L208 240zM208 192L208 144C208 82.1 258.1 32 320 32C381.9 32 432 82.1 432 144L432 192L496 192C522.5 192 544 213.5 544 240L544 448C544 501 501 544 448 544L192 544C139 544 96 501 96 448L96 240C96 213.5 117.5 192 144 192L208 192z"
                fill="currentColor"
            />
        </svg>
    );
}

export default IconBagShopping;
